import {
    withStyles,
} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

export default withStyles({
    root: {
        '& .MuiTextField-root':{
            color: "rgb(103, 212, 239)"
        },
        '& label': {
            color: "rgb(103, 212, 239)",
        },

        '& .MuiInput-input': {
            color: "white",
        },

        '& label.Mui-focused': {
            color: "rgb(103, 212, 239)",
        },
        '& .MuiInput-underline': {
            borderBottomColor: "rgb(103, 212, 239)",
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: "rgb(103, 212, 239)",
        }
        
    }
})(TextField);



// export default function CustomizedInputs(props) {
//     //const classes = useStyles();

//     return (
//         <form style={{ color: "white" }} noValidate>
//             <CssTextField   id="custom-textfield" label={"hi"} />
//         </form>
//     );
// }
